import { render, staticRenderFns } from "./simpleRecommend.vue?vue&type=template&id=2db60755&scoped=true&"
import script from "./simpleRecommend.vue?vue&type=script&lang=js&"
export * from "./simpleRecommend.vue?vue&type=script&lang=js&"
import style0 from "./simpleRecommend.vue?vue&type=style&index=0&id=2db60755&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db60755",
  null
  
)

export default component.exports